module.exports = __webpack_public_path__ + "img/back_100.ca0a0d56.jpg";